import React, { ReactNode, CSSProperties } from 'react';
import './styles.scss';

interface OrganisationCardProps {
  title: string;
  description: string;
  children: ReactNode;
  contentStyle?: CSSProperties;
}

export const OrganisationCard: React.FC<OrganisationCardProps> = ({
  title,
  description,
  children,
  contentStyle,
}) => {
  return (
    <div
      className={
        'organisation-card tw-bg-white dark:tw-bg-dark-card tw-text-gray-custom-900 '
        + 'dark:tw-text-dark-foreground tw-border tw-border-solid tw-border-transparent dark:tw-border-dark-border'
      }
    >
      <div className="organisation-card__body">
        <div className="organisation-card__left">
          <div className="organisation-card__title tw-text-gray-custom-900 dark:tw-text-dark-foreground">
            {title}
          </div>
          <div className="organisation-card__description tw-text-gray-custom-700 dark:tw-text-dark-paragraph-2">
            {description}
          </div>
        </div>
        <div className="organisation-card__right">
          <div
            className="organisation-card__right-content"
            style={contentStyle}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganisationCard;
